import { useMutation } from "@apollo/client/react";
import toast from "react-hot-toast";
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import { DELETE_INDICACION } from "../../../../../data/graphQL/mutations/GestionAsistencial/deleteIndicacion";

export function TabIndicationDeleteIndicacionDialog({
  open,
  handleCloseDialog,
  indicationSelected,
  deleteRow
}) {
  const [deleteIndicacion, { loading }] = useMutation(DELETE_INDICACION, {
    onCompleted: (data) => {
      const { success, error, valorEsperado } = data?.deleteIndicacion || {};
      if (success && valorEsperado) {
        deleteRow(indicationSelected);
        handleCloseDialog();
        toast.success(`Indicación con ID ${indicationSelected} eliminada con éxito.`);
      } else {
        toast.error(error);
      }
    }
  });

  const handleAcceptUpdate = () => {
    deleteIndicacion({
      variables: { idIndicacion: indicationSelected }
    });
  };

  return (
    <CustomDialog
      title="Eliminar indicación"
      open={open}
      fullWidth
      maxWidth="sm"
      onCancel={handleCloseDialog}
      onAccept={handleAcceptUpdate}
      cancelText="Cancelar"
      acceptText="Eliminar"
      acceptLoading={loading}
      acceptDisabled={loading}>
      
      ¿Usted esta seguro/a que desea eliminar la indicación?
    </CustomDialog>);

}